import { isArray } from "lodash";
import { get } from "lodash";

export const safeParseJson = (str) => {
    try {
        const parsed = JSON.parse(str);
        if (typeof parsed === 'object' && parsed !== null)
            return parsed;
        return undefined;
    } catch (e) {
        return undefined;
    }
};

export const convertStringToCustomDataObj = (str) => {
    const parts = str.split('#');

    if (parts.length < 4) return str; // Ensure all parts exist

    const [label, key, isListRaw, type, index, required] = parts;

    return {
        label,
        key,
        isList: isListRaw === 'true',
        type,
        index,
        required
    };
};

export const convertCustomDataObjToString = (obj) => {
    const {
        label = '',
        key = '',
        isList = false,
        type = '',
        index = '',
        required = '',
    } = obj;

    return [label, key, isList, type, index, required].join('#');
};

export const importAnnotationsFromJSONString = (flatten, docViewer) => {
    if (!docViewer) return;
    const annotes = JSON.parse(flatten);
    if (!!annotes && isArray(annotes)) {
        annotes?.forEach(annote => {
            docViewer.addAnnotations(annote);
        })
    }
}

export const getFormFieldTypeFromAnnote = (annote) => {
    const customData = convertStringToCustomDataObj(annote?.fieldName);
    return getFormFieldType(customData?.type);
}

export const getFormFieldType = (type) => {
    if (type === "bool") return "checkbox";
    else if (type === "signature") return "signatureFields";
    return "textfield";
}

export const getValueFromProviderData = (
    data,
    customDataStr,
    includeLabelAsDefault = true
) => {
    const customData = convertStringToCustomDataObj(customDataStr);
    let defaultValue = includeLabelAsDefault ? customData?.label : "";

    if (!data || !customData?.key) return defaultValue;
    else {
        try {
            let property_path = customData?.key?.split(".");

            let index = customData?.index;
            if (!!index) {
                property_path.splice(1, 0, index);
            }
            console.log({ data, property_path });
            const value = get(data, property_path, defaultValue);

            if (customData?.type === "bool")
                return value === "true" || value === true ? "On" : "Off";
            else return value || "";
        } catch (error) {
            return defaultValue;
        }
    }
};
